import { createSelector } from 'reselect';

import { selectStore } from './stateSelectors';

export const selectEditMatchesEventObject = createSelector(selectStore, (events) => events.editMatchesEventObject);
